import { useMemo } from 'react'
import { useGeneralAgentChatStore } from '../../hooks/generalAgentChatStore'
import { questionsOfTab } from '../../hooks/toolQuestions'
import { ToolQuestionCard } from './ToolQuestionCard'

/** The open chat's card questions, under its newest message: a question ends its turn, so it is the latest thing said. */
export const ToolQuestionThread = () => {
    const tabId = useGeneralAgentChatStore((s) => s.tabId)
    const pendingQuestions = useGeneralAgentChatStore((s) => s.pendingQuestions)
    const answerQuestion = useGeneralAgentChatStore((s) => s.answerQuestion)
    const questions = useMemo(() => questionsOfTab(pendingQuestions, tabId), [pendingQuestions, tabId])

    if (!questions.length) return null
    return (
        <div className="mt-3 flex flex-col gap-3">
            {questions.map((q) => (
                <ToolQuestionCard key={q.questionId} question={q} onAnswer={(action) => void answerQuestion(q.questionId, action)} />
            ))}
        </div>
    )
}
